/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Readiness_OkInputs */

const cs_portals_readiness_ok = /** @type {(inputs: Portals_Readiness_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připraveno pro všechny zapnuté portály`)
};

const en_portals_readiness_ok = /** @type {(inputs: Portals_Readiness_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for all enabled portals`)
};

/**
* | output |
* | --- |
* | "Ready for all enabled portals" |
*
* @param {Portals_Readiness_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_readiness_ok = /** @type {((inputs?: Portals_Readiness_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Readiness_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_readiness_ok(inputs)
	return cs_portals_readiness_ok(inputs)
});